import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./signInTask.html"
})

export class SignInTask implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];
  private dataPush:any={};

  ngOnInit(): void {
    this.getData();
    this.getDataTime();
  }



  private getData(){
    this.http.getData(API.sign_in).then(res=>{
      this.data=res.data;
    });
  }

  private editSignTask(id:number){
    this.router.navigate(['index/signInTask',id]);
  }

  //设置签到时间开关
  private getDataTime(){
    this.http.getData(API.challengePushType).then(res=>{
      this.dataPush=res.data;
      console.log(this.dataPush)
    });
  }

  private editChallenge(type:any){
    this.router.navigate(['index/challengeTask',type]);
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/badge/signInTask.component.ts